
import React, { useEffect, useState, useMemo } from 'react'; 
import './dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faUndo } from '@fortawesome/free-solid-svg-icons';

import { faPlus, faUsers } from '@fortawesome/free-solid-svg-icons';

function Dashboard() {
  // --- États globaux ---
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  const [currentRole, setCurrentRole] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [showTrash, setShowTrash] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
 

  // --- États pour le formulaire de création ---
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: 'Admin',
  });

  const [form, setForm] = useState({
    name: '',
    email: '',
    password: '',
    role: 'Admin',
    license: '',
  });

  // --- États pour l’édition ---
  const [editForm, setEditForm] = useState({ name: '', email: '', role: '' });

  // --- Données locales ---
  const token = localStorage.getItem('token');
  

  // --- Statistiques utilisateurs ---
  const stats = useMemo(() => {
    const total = users.length;
    const active = users.filter(user => !user.deletedAt).length;
    const deleted = users.filter(user => !!user.deletedAt).length;
    return { total, active, deleted };
  }, [users]);

  // --- Chargement des utilisateurs ---
  const fetchUsers = async () => {
    try {
      const response = await fetch('/user/users', {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      if (!response.ok) throw new Error('Erreur lors du chargement des utilisateurs');
      const data = await response.json();
      setUsers(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // --- Gestion des champs du formulaire de création ---
  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // --- Création d’un nouvel utilisateur ---
  const handleCreateUser = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (form.role === 'SuperAdmin' && !form.license.trim()) {
      setError('Le champ license est obligatoire pour un SuperAdmin.');
      return;
    }

    const endpoint = form.role === 'SuperAdmin' ? '/auth/create/superadmin' : '/auth/create-admin';

    const requestBody = form.role === 'SuperAdmin'
      ? { name: form.name, email: form.email, password: form.password, license: form.license }
      : { name: form.name, email: form.email, password: form.password };

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || 'Erreur lors de la création');
      }

      setMessage('Utilisateur créé avec succès');
      setForm({ name: '', email: '', password: '', role: 'Admin', license: '' });
      setShowCreateForm(false);
      fetchUsers();
    } catch (err) {
      setError(err.message);
    }
  };

  // --- Suppression (soft delete) d’un utilisateur ---
  const deleteUser = async (id) => {
    try {
      await fetch(`/user/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers((prev) =>
        prev.map((user) =>
          user.id === id ? { ...user, deletedAt: new Date().toISOString() } : user
        )
      );
    } catch (err) {
      console.error('Erreur lors de la suppression:', err);
    }
  };

  // --- Restauration d’un utilisateur supprimé ---
  const restoreUser = async (id) => {
    try {
      await fetch(`/user/restore/id/${id}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers((prev) =>
        prev.map((user) =>
          user.id === id ? { ...user, deletedAt: null } : user
        )
      );
    } catch (err) {
      console.error('Erreur lors de la restauration:', err);
    }
  };

  // --- Préparation de la modification d’un utilisateur ---
  const handleEditUser = (user) => {
    setEditingUser(user);
    setEditForm({ name: user.name, email: user.email, role: user.role });
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  // --- Suivi des changements dans le formulaire d’édition ---
  const handleEditFormChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  // --- Soumission du formulaire de modification ---
  const submitEditForm = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`/user/${editingUser.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editForm),
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || 'Erreur de mise à jour');
      }

      setMessage('Utilisateur mis à jour');
      setEditingUser(null);
      fetchUsers();
    } catch (err) {
      setError(err.message);
    }
  };

  // --- Rendu principal ---
  return (
    <div className="dashboard-container">
  <div className="top-bar">
    <h3>Gestion des utilisateurs</h3>
    <div>
      <button onClick={() => setShowCreateForm(true)} className="bout-new">
  <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
  Nouveau admin
</button>

<button onClick={() => setShowTrash(prev => !prev)} className="bout-trash">
  <FontAwesomeIcon
    icon={showTrash ? faUsers : faTrash}
    style={{ marginRight: '8px' }}
  />
  {showTrash ? 'Liste des utilisateurs' : 'Corbeille'}
</button>

    </div>
  </div>

  <div className="stats">
    <div className="stat-card">
      <h4>Nombre total d’utilisateurs</h4>
      <p>{stats.total}</p>
    </div>
    <div className="stat-card">
      <h4>Utilisateurs actifs</h4>
      <p>{stats.active}</p>
    </div>
    <div className="stat-card">
      <h4>Utilisateurs supprimés</h4>
      <p>{stats.deleted}</p>
    </div>
  </div>


      {/* Formulaire de création */}
      {showCreateForm && (
        <form >
          <h3>Créer un Admin ou SuperAdmin</h3>
          <input type="text" name="name" placeholder="Nom" value={form.name} onChange={handleInputChange} required /><br />
          <input type="email" name="email" placeholder="Email" value={form.email} onChange={handleInputChange} required /><br />
          <input type="password" name="password" placeholder="Mot de passe" value={form.password} onChange={handleInputChange} required /><br />
          <select name="role" value={form.role} onChange={handleInputChange} required>
            <option value="Admin">Admin</option>
            <option value="SuperAdmin">SuperAdmin</option>
          </select><br />
          {form.role === 'SuperAdmin' && (
            <>
              <input type="text" name="license" placeholder="License SuperAdmin" value={form.license} onChange={handleInputChange} required /><br />
            </>
          )}
          <button class="create" type="submit" onClick={handleCreateUser}>Créer</button>
          <button class="cancel" type="button" onClick={() => setShowCreateForm(false)} >Annuler</button>
        </form>
      )}

      {/* Table des utilisateurs */}
      <div class="liste" className="p-4">
        <h3 class="listeh" >Liste des utilisateurs</h3>
        <table >
          <thead >
            <tr>
              <th className="p-2 border">Name</th>
              <th className="p-2 border">Email</th>
              <th className="p-2 border">Role</th>
              <th className="p-2 border">Status</th>
              <th className="p-2 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users
              .filter(user => (showTrash ? user.deletedAt : !user.deletedAt))
              .map(user => (
                <tr key={user.id} className="text-center">
                  <td className="p-2 border">{user.name}</td>
                  <td className="p-2 border">{user.email}</td>
                  <td className="p-2 border">{user.role}</td>
                  <td className="p-2 border">{user.deletedAt ? 'Deleted' : 'Active'}</td>
                  <td className="p-2 border">
                    {!user.deletedAt ? (
                      <button onClick={() => deleteUser(user.id)} class="icon-button">
    <FontAwesomeIcon icon={faTrash} />
  </button>
) : (
  <button onClick={() => restoreUser(user.id)} class="icon-button">
    <FontAwesomeIcon icon={faUndo} />
  </button>
)}

<button onClick={() => handleEditUser(user)} class="icon-button">
  <FontAwesomeIcon icon={faEdit} />
</button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {/* Formulaire de modification */}
      {editingUser && (
        <form >
          <h3>Modifier utilisateur : {editingUser.name}</h3>
          <input type="text" name="name" value={editForm.name} onChange={handleEditFormChange} required /><br />
          <input type="email" name="email" value={editForm.email} onChange={handleEditFormChange} required /><br />
          <button class="create" type="submit" onClick={submitEditForm}>Valider</button>
          <button class="cancel" onClick={() => setEditingUser(null)}>Annuler</button>
        </form>
      )}
        <h6 class="centered-h6">
          © 2025 Junior Entreprise Insat. Tous droits réservés.
        </h6>   
        </div>
    
  );
}

export default Dashboard;
